<template>
  <div class="nav-tabs-wrapper">
    <ul class="nav nav-tabs">
      <li v-for="tab in tabs" :key="useRoutes ?  tab.routeName : tab.key"
        class="tablink-container"
        :class="{ 'active': tabSelected(tab) }"
      >
        <router-link v-if="useRoutes"
          :to="{ name: tab.routeName, params: tab.routeParams }"
          class="k-tablink">
          {{ tab.name }}
        </router-link>
        <a v-else @click="$emit('tab-selected', tab.key)" :aria-current="tabSelected(tab) ? 'page' : undefined">{{ tab.name }}</a>
      </li>
    </ul>
  </div>
</template>

<style scoped>
li.tablink-container a:focus-visible {
  outline: var(--kate-focus-ring-width) solid var(--kate-focus-ring-color);
  outline-offset: -2px;
  box-shadow: 0 -4px 0 var(--kate-primary) inset;
}
</style>

<script>
export default {
  watch: {
    currentTab(newVal) {
      this.setUrlQueryParam(newVal);
    },
    '$route.query': {
      handler(newQuery) {
        if (!this.useRoutes && this.useUrlQueryParams) {
          const tabFromQuery = newQuery?.[this.tabParamName];
          if (typeof tabFromQuery === 'string' && tabFromQuery !== this.currentTab) {
            this.$emit('tab-selected', tabFromQuery);
          }
        }
      },
      immediate: true,
    },
  },

  beforeMount() {
    this.setDefaultUrlQueryParam();
    this.setCurrentTab();
  },

  props: {
    currentTab: {
      type: String,
    },
    tabs: {
      type: Array,
    },
    useRoutes: {
      type: Boolean,
      default: true,
    },
    useUrlQueryParams: {
      type: Boolean,
      default: false,
    },
    tabParamName: {
      type: String,
      default: 'tab',
    },
  },

  methods: {
    tabSelected(tab) {
      return this.useRoutes ? this.currentTab === tab.routeName : this.currentTab === tab.key;
    },

    setUrlQueryParam(tabKey) {
      if (!this.useRoutes && tabKey && this.useUrlQueryParams) {
        this.$router.replace({ query: { ...this.$route?.query, [this.tabParamName]: tabKey } });
      }
    },

    setDefaultUrlQueryParam() {
      if (!this.useRoutes && !this.$route?.query?.tab && this.useUrlQueryParams && this.tabs.length) {
        this.$router.replace({ query: { ...this.$route?.query, [this.tabParamName]: this.tabs[0].key } });
      }
    },

    setCurrentTab() {
      if (!this.useRoutes && this.$route?.query?.tab && this.useUrlQueryParams) {
        this.$emit('tab-selected', this.$route.query[this.tabParamName]);
      }
    },
  },
};
</script>
